const state = {
    abTests: []
}

const actions = {
    async getTests({ commit }, entity) {
        let { entityId, results } = await getTests(entity);
        commit('setTestsForEntity', { entityId, results });
    }
}

const mutations = {
    setTestsForEntity(state, data) {
        state.abTests = state.abTests.filter(x => x.entityId != data.entityId);
        state.abTests = state.abTests.concat(data.results);
    }
}

async function getTests(entity) {
    let { employerId, participantId } = entity;
    
    let entityType = null;
    let entityId = null;

    if(employerId) {
        entityType = 'employer';
        entityId = employerId;
    }
    else if(participantId) {
        entityType = 'participant';
        entityId = participantId;
    }

    var results = await romeApi.get(`${entityType}/${entityId}/ab-testing`);
    return { entityId, results };
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/ab-testing/x-ab-tests.js